<template>
  <div class = "flex-1-1">
    <fire-toast/>
    <div class="AGENDA fd-column:mo ">
      <div @click="onCalendarToggle" v-if="$device.isMobileOrTablet && hideCalendar">
        <vk-icon
            name="arrow-left"
            size="25"
            class="ARROW"/>
      </div>
      <h2
          class="HEADING
        d-flex flex-1-1 m-l-1:mo text-center:mo fd-column m-r-1 m-r-6:w" > {{ scheduleTitle }} </h2>
      <div class="SEARCHWRAPPER w-100:mo p-b-2:mo">
        <job-search-box
            :redirectToJobs="redirectToJobs"
            @input-focus="onSearchFocus"
            @input-blur="onSearchBlur"
            @input-cleared="reset()"
            v-model="valueSearch"
            class="m-t-2 w-100"/>
        <input
            v-if="showCancel"
            type="button"
            value="Cancel"
            class="btn btn-sm btn-tertiary BUTTON m-t-2"
            @click="onClearSearch()">
      </div>
    </div>
    <div v-if="selectedViewOption === $options.VIEW_OPTIONS.LIST">
      <view-selection @view-change="onViewChange"/>
      <div >
        <div class="d-flex flex-1-1 fd-column ov-y-hidden">
          <appointment-list @onDelete="appointmentDelete" :key="appointmentKey"/>
        </div>
        <div class="AGENDA">
          <h2
              class="HEADING d-flex flex-1-1 m-l-1:mo fd-column m-r-1 m-r-6:w"
          >Paused Lead Dates</h2>
          <div class="SEARCHWRAPPER jc-end">
            <a
                class="ADD-NOTE ANCHOR-CONTROLS"
                @click.prevent="onEdit">
              + Add new pause
            </a>
          </div>
        </div>
        <div class="d-flex flex-1-1 fd-column ov-y-hidden p-b-2">
          <paused-leads-list @onEdit="onEdit" @onDelete="pauseDelete"/>
        </div>
        <div class="LINK d-flex p-2">
          <div>
            <vk-icon
                name="information-filled"
                size="22"
                class=" p-r-1"
                unbounded/>
          </div>
          <a
              :href="pauseLeadsLink"
              rel="noopener noreferrer"
              target="_blank">Why should I pause my leads?</a>
        </div>
      </div>
    </div>
    <div v-else :class="{'MOBILE' : $device.isMobileOrTablet}">
      <div class="d-flex jc-end ">
        <a
            class="ADD-NEW-PAUSE m-l-1:mo flex-0-0 cur-pointer m-r-1 m-b-1"
            @click.prevent="onEdit">
          + Add new pause
        </a>
      </div>
      <month-display
          @view-change="onViewChange"
          @date-change="onDateChange"
          @onEdit="onEdit"
          @onPauseDelete="pauseDelete"
          @onDelete="appointmentDelete"
          @dayClick="onCalendarToggle"
          :dateSelected="dateSelected"
          :updateEvents="updateEvents"
          :hideCalendar="hideCalendar"
      />
    </div>
    <availability-modal
        v-if="isAvailabilityModalOpen"
        @close="onAvailabilityModalClose"
        :pause="pause"/>
    <one-time-survey-modal
        v-if="isOneTimeSurveyOpen"
        @secondary="onSurveyClose"
    />
    <delete-modal
        :isOpen="isDeleteModalOpen"
        @secondary="onDeleteModalClose"
        :deleteItem="deleteItem"
        :deleteType="typeOfDelete"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Storage from '@homeservices/tool-kit/storage/local-storage';
import JobSearchBox from '@/components/JobSearchBox';
import { VIEW_OPTIONS } from '@/constants/schedule-view-selections';
import AppointmentList from './components/AppointmentList';
import PausedLeadsList from './components/PausedLeadsList';
import AvailabilityModal from '../../components/AvailabilityModal';
import OneTimeSurveyModal from '../../components/OneTimeSurveyModal';
import DeleteModal from '../../components/DeleteModal';
import MonthDisplay from './components/MonthSection/MonthDisplay';
import ViewSelection from './components/MonthSection/ViewSelection';

const REMEMBER_VIEW_KEY = 'PR_REMEMBER_SCHEDULE_VIEW';
export default {
  name: 'dashboard-agenda',
  VIEW_OPTIONS,
  components: {
    JobSearchBox,
    AppointmentList,
    PausedLeadsList,
    AvailabilityModal,
    OneTimeSurveyModal,
    DeleteModal,
    MonthDisplay,
    ViewSelection,
  },
  data () {
    return {
      redirectToJobs: true,
      showCancel: false,
      valueSearch: '',
      isAvailabilityModalOpen: false,
      isOneTimeSurveyOpen: false,
      pause: {},
      appointmentItem: {},
      isDeleteModalOpen: false,
      typeOfDelete: '',
      appointmentKey: 0,
      updateEvents: 0,
      viewOptions: [VIEW_OPTIONS.LIST, VIEW_OPTIONS.MONTH],
      selectedViewOption: Storage.get(REMEMBER_VIEW_KEY) || VIEW_OPTIONS.LIST,
      dateSelected: new Date(),
      todaysPauses: [],
      hideCalendar: false,
    };
  },
  computed: {
    ...mapGetters('account/pro', [
      'hasTakenOneTimeSurvey',
    ]),
    scheduleTitle () {
      return this.selectedViewOption === VIEW_OPTIONS.LIST ? 'Appointments' : 'Schedule';
    },
    deleteItem () {
      return this.typeOfDelete === 'pause' ? this.pause : this.appointmentItem;
    },
    displayText () {
      return this.selectedViewOption;
    },
    pauseLeadsLink () {
      return `${this.$runtimeConstants.SALESFORCE_ACCOUNT_REDIRECT_DOMAIN}/prohelpcenter/s/article/Pausing-leads?login=true`;
    },
  },
  created () {
    this.checkForSubmittedSurvey();
  },
  methods: {
    onViewChange (option) {
      this.selectedViewOption = option;
    },
    onDateChange (date) {
      this.dateSelected = date;
    },
    onClearSearch () {
      this.showCancel = false;
      this.valueSearch = '';
    },
    reset () {
      this.redirectToJobs = true;
    },
    onSearchFocus () {
      this.showCancel = true;
    },
    onSearchBlur (evt) {
      if (!evt) {
        this.showCancel = false;
      }
    },
    onAvailabilityModalClose () {
      this.isAvailabilityModalOpen = false;
      this.updateEvents += 1;
      this.appointmentKey += 1;
    },
    onSurveyClose () {
      this.isOneTimeSurveyOpen = false;
    },
    onEdit (pause) {
      this.pause = pause.id ? pause : {};
      this.isAvailabilityModalOpen = true;
    },
    onDeleteModalClose () {
      this.isDeleteModalOpen = false;
      this.appointmentKey += 1;
      this.updateEvents += 1;
    },
    appointmentDelete (item) {
      this.appointmentItem = item;
      this.typeOfDelete = 'appointment';
      this.isDeleteModalOpen = true;
    },
    pauseDelete (pause) {
      this.pause = pause;
      this.typeOfDelete = 'pause';
      this.isDeleteModalOpen = true;
    },
    checkForSubmittedSurvey () {
      if (!this.hasTakenOneTimeSurvey) {
        this.isOneTimeSurveyOpen = true;
      }
    },
    onCalendarToggle () {
      this.hideCalendar = !this.hideCalendar;
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";
  .AGENDA {
    padding: 1*$unit 1*$unit;
    display: flex;
    @include mobile-only{
      width:100vw;
    }
    .SEARCHWRAPPER {
      @include tablet() {
        width: 460px;
      }
        display: flex;
    }
    .CANCELBUTTON {
      display: flex;
      flex: initial;
    }
    .BUTTON {
      border-color: #fff;
    }
    .ADD-NOTE {
      @include link-primary;
      @include text-large;
      @include text-large;
      @include hover(text-decoration, none, none);
      display: flex;
      align-items: center;

      @include desktop {
        @include text-medium;
      }

      .ICON {
        margin-right: $unit;
      }
    }
  }
  a, .LINK {
    text-decoration: underline;
    color:#3E7697;

  }
  .OPTIONS {
    @include text-medium;
    width:$unit * 12;

    /deep/ .input {
      padding: $unit;
      border: none;
      font-weight: 700;
      color: $color-gray80;
      .VK-LISTBOX-TEXT {
        padding-right: $unit;
      }

      .CHEVRON {
        color: $color-depot;
      }
    }
    /deep/ .MENU {
      top: 4*$unit;
      right: 0;
      height: auto;
      width: 100px;
      padding: $unit 0;
      border: none;
      overflow: auto;
      background-color: transparent;
    }
  }
  .OPTION {
    background-color: white;
    border-bottom: solid 1px $color-gray50;
    @include hover(transform, none, none);
    transition: none;
  }
  .ADD-NEW-PAUSE {
    position:absolute;
    color: $color-depot;
    text-decoration: none;
    font-weight: 700;
    background-color: white;
    margin-top: 5 * $unit;
    padding:  $unit 2 * $unit;
    align-self: center;
    @include mobile-only{
      margin-top: 2*$unit;
      position:relative;

    }
  }
  .ARROW {
    position: absolute;
    top: $unit * 4;
    @include tablet {
      position: relative;
      margin-right: $unit;
      padding-top: 4 * $unit;
    }
  }
  .MOBILE {
    display: flex;
    flex-direction: column-reverse;
  }
</style>
